// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/parcel-temperature-lapse-rates.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/parcel-temperature-lapse-rates/parcel-temperature-lapse-rates.js';

mount([g0]);
